import React, { useState } from 'react';
import { IoEyeSharp } from 'react-icons/io5'
import { useDispatch } from 'react-redux';
import { addToCartList } from '../../../redux/slice/productslice';
import './Card.css'
import CardModal from './CardModal';


const Card = ({ product }) => {
  const { title, price, imgUrl } = product
  const [modal, setModal] = useState(false)
  const dispatch = useDispatch()
  return (
    <>
      <div className="cardHover hover:bg-gray-100 hover:shadow-md cursor-pointer">
        <div className="block relative h-48 rounded overflow-hidden">
          <img alt="ecommerce" className="w-full imgHover" src={imgUrl} />
          <div className="w-full">
            <button onClick={() => setModal(!modal)} className='absolute -bottom-2 left-2 right-2 mx-auto bg-sky-600 rounded-t-md px-1 quick font-normal text-md pb-2 text-white text-md flex justify-center items-center gap-x-1 shadow-4xl'><IoEyeSharp />Quick View</button>
          </div>
        </div>
        <div className="space-y-1 mb-2">
          <div className="min-h-16">
            <h3 className="text-gray-900 text-sm mb-1 text-center">{title}</h3>
          </div>
          <h2 className="text-gray-500  text-md  text-center">100 ml</h2>
          <p className=" text-center text-lg font-semibold text-red-600">tk.{price}  <span className='text-gray-500 line-through font-normal'>{price - 110}</span></p>
          <p onClick={() => dispatch(addToCartList(product._id))} className='border border-yellow-300 px-3 py-2 rounded-md text-center mx-3 cartbtn'>Add To Cart</p>
        </div>
      </div>
      <CardModal setModal={setModal} modal={modal} />
    </>
  );
};

export default Card;